/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import PropTypes from "prop-types";

import { Wrapper } from "../../sharedComponents/Wrapper";

// eslint-disable-next-line import/no-cycle
import { QuickLinksConnector } from "../QuickLinks";

import { HardCodedConnector } from "../HardCoded";

// eslint-disable-next-line import/no-cycle
import { ContentTextSectionConnector } from "../ContentTextSection";

// eslint-disable-next-line import/no-cycle
import { ThingsToDoConnector } from "../ThingsToDo/ThingsToDo";

// eslint-disable-next-line import/no-cycle
import { TipsConnector } from "../Tips";

// eslint-disable-next-line import/no-cycle
import { QuickLinksSupportConnector } from "../QuickLinksSupport";

import { VideoPlayerConnector } from "../VideoPlayer";

import { ListConnector } from "../List";

// eslint-disable-next-line import/no-cycle
import { IconLinksConnector } from "../IconLinks";

// eslint-disable-next-line import/no-cycle
import { LinksListConnector } from "../LinksList";

// eslint-disable-next-line import/no-cycle
import { ComponentBlock } from "../ComponentBlock";

import { SocialShareButtonsConnector } from "../SocialShareButtons";

// eslint-disable-next-line import/no-cycle
import { SocialFollowButtonsConnector } from "../SocialFollowButtons";

// eslint-disable-next-line import/no-cycle
import { FluidCollapsibleComponentConnector } from "../FluidCollapsibleComponent";

// eslint-disable-next-line import/no-cycle
import { BannerConnector } from "../Banner";

// import WelcomeMessageBlockConnector from "../WelcomeMessageBlock/WelcomeMessageBlockConnector";

// eslint-disable-next-line import/no-cycle
import { MagazinePreviewBlockConnector } from "../MagazinePreviewBlock";

// eslint-disable-next-line import/no-cycle
import { SplitContainerConnector } from "../SplitContainer";

import { MultiImageBlockConnector } from "../MultiImageBlock";

// eslint-disable-next-line import/no-cycle
import { ImageBannerWithContentConnector } from "../ImageBannerWithContent";

// eslint-disable-next-line import/no-cycle
import { ComponentsSliderConnector } from "../ComponentsSlider";

// eslint-disable-next-line import/no-cycle
import { SocialAndAppsSectionConnector } from "../SocialAndAppsSection";

import { TestimonialConnector } from "../Testimonial";

import { WhiteSpaceConnector } from "../WhiteSpace";

// eslint-disable-next-line import/no-cycle
import { ParagraphSectionConnector } from "../ParagraphSection";

import { InfoPanelConnector } from "../InfoPanel";

// eslint-disable-next-line import/no-cycle
import { TabsAndAccordionsConnector } from "../TabsAndAccordions";

// eslint-disable-next-line import/no-cycle
import { CardCollectionConnector } from "../CardCollection";

// eslint-disable-next-line import/no-cycle
import { HeaderTilesConnector } from "../HeaderTiles";

// eslint-disable-next-line import/no-cycle
import { FluidModal } from "../Modal/FluidModal";

// eslint-disable-next-line import/no-cycle
import { ComponentWrapperConnector } from "../ComponentWrapper";

// eslint-disable-next-line import/no-cycle
import { BrandsCarouselConnector } from "../BrandsCarousel";

// eslint-disable-next-line import/no-cycle
import { FAQs } from "../FAQs";

// eslint-disable-next-line import/no-cycle
import { CallToActionSectionsConnector } from "../CallToActionSections";

// eslint-disable-next-line import/no-cycle
import { PaginatedCollectionFluidConnector } from "../PaginatedCollectionFluid";

// eslint-disable-next-line import/no-cycle
import { CollapsibleLinksListConnector } from "../CollapsibleLinksList";

// eslint-disable-next-line import/no-cycle
import { HotelCardTabsConnector } from "../HotelCardTabs/HotelCardTabsConnector";

// eslint-disable-next-line import/no-cycle
import { LinkConnector } from "../Link/LinkConnector";

// eslint-disable-next-line import/no-cycle
import { TimedContent } from "../TimedContent";
import { PageContext } from "../PageContext";

// eslint-disable-next-line import/no-cycle
import { AlertComponentConnector } from "../AlertComponent/AlertComponentConnector";

// eslint-disable-next-line import/no-cycle
import { ResponsiveBannerConnector } from "../ResponsiveBanner/ResponsiveBannerConnector";

import { CountdownBannerConnector } from "../CountdownBanner/CountdownBannerConnector";

const FluidSections = ({ data, location, locale: providedLocale, useWrapper }) => {
	let { locale } = useContext(PageContext);
	if (providedLocale) {
		locale = providedLocale;
	}
	return (
		<>
			{data?.pageSections?.map(section => {
				const id = section?.sys?.contentType?.sys?.id;
				return (
					<ComponentWrapperConnector
						data={id === "componentWrapper" && section}
						locale={locale}
						useWrapper={
							useWrapper &&
							id !== "whiteSpaceComponent" &&
							id !== "componentBlock" &&
							id !== "responsiveBanner" &&
							id !== "timedComponent" &&
							id !== "countdownBanner"
						}>
						{(() => {
							switch (id) {
								case "quickLinks":
									return <QuickLinksConnector data={section} key={section.id} />;
								case "hardCodedComponent":
									return <HardCodedConnector data={section} key={section.id} />;
								case "contentTextSection":
									return <ContentTextSectionConnector data={section} key={section.id} />;
								case "thingsToDoTabs":
									return <ThingsToDoConnector data={section} key={section.id} />;
								case "tipsComponent":
									return <TipsConnector data={section} key={section.id} />;
								case "quickLinksSupport":
									return <QuickLinksSupportConnector data={section} key={section.id} />;
								case "videoPlayer":
									return <VideoPlayerConnector data={section} key={section.id} />;
								case "list":
									return <ListConnector data={section} key={section.id} />;
								case "iconLinks":
									return <IconLinksConnector data={section} key={section.id} locale={locale} />;
								case "linksList":
									return <LinksListConnector data={section} key={section.id} />;
								case "collapsibleLinksList":
									return <CollapsibleLinksListConnector data={section} key={section.id} />;
								case "fluidPaginatedEntries":
									return (
										<PaginatedCollectionFluidConnector
											data={section}
											locale={locale}
											key={section.id}
										/>
									);
								case "ctaSections":
									return <CallToActionSectionsConnector data={section} key={section.id} />;
								case "socialMediaShareButtons":
									return <SocialShareButtonsConnector data={section} key={section.id} />;
								case "socialFollowButtons":
									return <SocialFollowButtonsConnector data={section} key={section.id} />;
								case "fluidCollapsibleComponent":
									return (
										<FluidCollapsibleComponentConnector
											data={section}
											locale={locale}
											key={section.id}
										/>
									);
								case "banner":
									return <BannerConnector data={section} key={section.id} locale={locale} />;
								case "magazinePreviewBlock":
									return <MagazinePreviewBlockConnector data={section} key={section.id} />;
								case "splitContentWrapper":
									return (
										<SplitContainerConnector data={section} locale={locale} key={section.id} />
									);
								case "multiImageBlock":
									return <MultiImageBlockConnector data={section} key={section.id} />;
								case "imageBannerWithContent":
									return <ImageBannerWithContentConnector data={section} key={section.id} />;
								case "componentSlider":
									return (
										<ComponentsSliderConnector data={section} locale={locale} key={section.id} />
									);
								case "whiteSpaceComponent":
									return <WhiteSpaceConnector data={section} key={section.id} />;
								case "testimonial":
									return <TestimonialConnector data={section} key={section.id} />;
								case "socialMediaSection":
									return <SocialAndAppsSectionConnector data={section} key={section.id} />;
								case "tabsAndAccordions":
									return (
										<TabsAndAccordionsConnector data={section} locale={locale} key={section.id} />
									);
								case "cardCollection":
									return (
										<CardCollectionConnector data={section} locale={locale} key={section.id} />
									);
								case "paragraphSection":
									return <ParagraphSectionConnector data={section} key={section.id} />;
								case "componentBlock":
									return <ComponentBlock data={section} locale={locale} key={section.id} />;
								case "teamMembers":
									return <InfoPanelConnector data={section} key={section.id} />;
								case "modal":
									return <FluidModal data={section} locale={locale} key={section.id} />;
								case "hotelChainsCarousel":
									return (
										<BrandsCarouselConnector data={section} locale={locale} key={section.id} />
									);
								case "topTiles":
									return <HeaderTilesConnector data={section} key={section.id} locale={locale} />;
								case "promotionRule":
									return <HotelCardTabsConnector data={section} locale={locale} key={section.id} />;
								case "link":
									return <LinkConnector data={section} key={section.id} />;
								case "timedComponent":
									return <TimedContent data={section} key={section.id} />;
								case "alertComponent":
									return <AlertComponentConnector data={section} key={section.id} />;
								case "responsiveBanner":
									return <ResponsiveBannerConnector data={section} key={section.id} />;
								case "countdownBanner":
									return <CountdownBannerConnector data={section} key={section.id} />;
								case "componentWrapper":
									return (
										<FluidSections
											useWrapper={false}
											data={section.wrapperSections}
											locale={locale}
										/>
									);
								default:
									return null;
							}
						})()}
					</ComponentWrapperConnector>
				);
			})}
			{data?.__typename === "ContentfulFluidPageSections" && <FAQs data={data} />}
		</>
	);
};

export default FluidSections;
export { FluidSections };

/* Declare page prop */
FluidSections.propTypes = {
	data: PropTypes.object.isRequired,
	location: PropTypes.object,
	locale: PropTypes.string,
	useWrapper: PropTypes.bool,
};

FluidSections.defaultProps = {
	useWrapper: true,
	location: null,
	locale: null,
};
